import type { BleTransportDiagnostics } from './transports/WebBluetoothTransport';
import type { PrinterModelId } from './printerModelConfig';
import type { PrinterCapabilities } from './types';

export type RecommendedPrintTransport = 'usb-serial' | 'bluetooth-serial' | 'ble' | 'none';

/**
 * XP-P203A: prefer Web Serial over Bluetooth RFCOMM (SPP) at 115200 — not BLE GATT.
 * ISSC GATT bridges often accept writes but never print on Printer001-* firmware.
 */
export function getRecommendedPrintTransport(
  modelId: PrinterModelId,
  capabilities: PrinterCapabilities,
  bleDiagnostics: BleTransportDiagnostics | null,
): RecommendedPrintTransport {
  if (!capabilities.canPrint) return 'none';

  if (modelId === 'xp-p203a') {
    if (capabilities.webSerial) {
      if (
        capabilities.platform === 'windows' ||
        capabilities.platform === 'macos' ||
        capabilities.platform === 'linux'
      ) {
        return 'usb-serial';
      }
      if (capabilities.platform === 'android') {
        return 'bluetooth-serial';
      }
      return 'bluetooth-serial';
    }
    if (capabilities.webBluetooth) {
      if (bleDiagnostics?.bridgeProfile === 'issc' && bleDiagnostics.isscCreditFlow === 'delay-only') {
        return 'ble';
      }
      return 'ble';
    }
  }

  if (capabilities.webSerial) return 'usb-serial';
  if (capabilities.webBluetooth) return 'ble';
  return 'none';
}

export function isIsscBleUnreliable(ble: BleTransportDiagnostics | null): boolean {
  return ble?.bridgeProfile === 'issc' && ble.isscCreditFlow === 'delay-only';
}
